import { render, staticRenderFns } from "./VistaCatastro.vue?vue&type=template&id=49f897a8&scoped=true"
import script from "./VistaCatastro.vue?vue&type=script&lang=js"
export * from "./VistaCatastro.vue?vue&type=script&lang=js"
import style0 from "./VistaCatastro.vue?vue&type=style&index=0&id=49f897a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f897a8",
  null
  
)

export default component.exports